<template>
  <div class="purchase-order">
    <PageHeader title="采购订单" icon="el-icon-shopping-bag-1" />
    <!-- 搜索栏 -->
    <el-card class="search-card">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="订单名称">
          <el-input v-model="searchForm.orderNo" placeholder="请输入订单名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="草稿" :value="1"></el-option>
            <el-option label="待审核" :value="2"></el-option>
            <el-option label="审批中" :value="3"></el-option>
            <el-option label="已通过" :value="4"></el-option>
            <el-option label="已拒绝" :value="5"></el-option>
            <el-option label="已取消" :value="6"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 主数据表格 -->
    <el-card class="table-card">
      <div slot="header" class="clearfix">
        <span>采购订单列表</span>
        <!-- <el-button style="float: right" type="primary" @click="handleCreate">新建采购订单</el-button> -->
      </div>

      <!-- 数据表格 -->
      <el-table v-loading="listLoading" :data="orderList" element-loading-text="Loading" border fit
        highlight-current-row style="margin: 20px 0;">

        <el-table-column label="订单名称" prop="order_name" align="center" />
        <el-table-column label="供应商" prop="supplier_name" align="center" />

        <el-table-column label="采购金额" prop="money" align="center">
          <template slot-scope="scope">
            {{ scope.row.money ? `¥${scope.row.money}` : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="已付款" prop="pay_money" align="center">
          <template slot-scope="scope">
            {{ scope.row.pay_money !== undefined && scope.row.pay_money !== null ? `¥${scope.row.pay_money}` : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="物流单号" prop="logistics_no" align="center" />

        <el-table-column label="工作流" align="center">
          <template slot-scope="{row}">
            <el-tag 
              size="medium" 
              :type="getTimelineNodeType(row.workflowStatus)" 
              style="cursor: pointer"
              @click="handleShowFlow(row)">
              {{ row.workflow?.workFlowName || '暂无工作流' }}
              <i class="el-icon-arrow-right el-icon--right"></i>
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="状态" align="center">
          <template slot-scope="{row}">
            <el-tag :type="getStatusType(row.status)">{{ getStatusText(row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="created_at" align="center">
          <template slot-scope="scope">
            {{ scope.row.created_at ? formatDateTime(scope.row.created_at) : '' }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="当前审批人" prop="nowApprover" align="center" /> -->
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-dropdown @command="(command) => handleCommand(command, scope.row)" trigger="click">
              <el-button type="primary" size="mini">
                处理 <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <!-- 草稿状态 -->
                <template v-if="scope.row.status === 1">
                  <!-- <el-dropdown-item command="edit">
                  <i class="el-icon-edit"></i>编辑
                </el-dropdown-item> -->
                  <el-dropdown-item command="detail">
                    <i class="el-icon-document"></i>明细
                  </el-dropdown-item>
                  <el-dropdown-item command="submit">
                    <i class="el-icon-check"></i>提交审核
                  </el-dropdown-item>
                  <el-dropdown-item command="delete" divided>
                    <i class="el-icon-delete"></i>删除
                  </el-dropdown-item>
                </template>

                <!-- 待审核状态 -->
                <template v-else-if="scope.row.status === 2">
                  <el-dropdown-item command="detail">
                    <i class="el-icon-document"></i>明细
                  </el-dropdown-item>
                  <el-dropdown-item command="approve">
                    <i class="el-icon-check"></i>审核
                  </el-dropdown-item>
                  <el-dropdown-item command="cancel">
                    <i class="el-icon-close"></i>取消
                  </el-dropdown-item>
                </template>

                <!-- 审核中状态 -->
                <template v-else-if="scope.row.status === 3">
                  <el-dropdown-item command="detail">
                    <i class="el-icon-document"></i>明细
                  </el-dropdown-item>
                  <el-dropdown-item command="approve">
                    <i class="el-icon-check"></i>审核
                  </el-dropdown-item>
                </template>

                <!-- 已通过状态 -->
                <template v-else-if="scope.row.status === 4">
                  <el-dropdown-item command="detail">
                    <i class="el-icon-document"></i>明细
                  </el-dropdown-item>
                  <el-dropdown-item command="payment">
                    <i class="el-icon-money"></i>申请付款
                  </el-dropdown-item>
                </template>

                <!-- 其他状态只显示明细 -->
                <template v-else>
                  <el-dropdown-item command="detail">
                    <i class="el-icon-document"></i>明细
                  </el-dropdown-item>
                </template>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <!-- 流程对话框 -->
      <el-dialog title="审批流程" :visible.sync="flowDialogVisible" width="700px" class="flow-dialog">
        <div v-loading="flowLoading">
          <el-timeline>
            <el-timeline-item v-for="(flow, index) in flowList" :key="index" :type="getTimelineNodeType(flow.status)"
              size="large">
              <div class="flow-item">
                <!-- 节点标题和状态 -->
                <div class="flow-header">
                  <span class="flow-title">
                    <span class="step-tag">步骤 {{ flow.step }}</span>
                    {{ flow.title }}
                  </span>
                  <el-tag size="mini" :type="getStatusTagType(flow.status)">
                    {{ flow.statusText }}
                  </el-tag>
                </div>

                <!-- 审批人信息 -->
                <div class="flow-content">
                  <div class="flow-info">
                    <div class="info-header">
                      <i class="el-icon-user"></i>
                      <span>审批人</span>
                    </div>
                    <div class="approver-list">
                      <template v-if="flow.approverDetails && flow.approverDetails.length">
                        <div v-for="(approver, idx) in flow.approverDetails" :key="idx" class="approver-item">
                          <!-- 审批人基本信息 -->
                          <div class="approver-row">
                            <span class="approver-name">{{ approver.name }}</span>
                            <el-tag size="mini" :type="getStatusTagType(approver.status)"
                              :class="{ 'pending-status': approver.status === 0 }">
                              {{ getApproverStatusText(approver.status) }}
                            </el-tag>
                            <span class="approve-time">
                              {{ approver.time ? formatDateTime(approver.time) : '' }}
                            </span>
                          </div>

                          <!-- 审批意见 -->
                          <div v-if="approver.comment" class="approve-comment">
                            <span class="comment-label">审核意见：</span>
                            <span class="comment-text">{{ approver.comment }}</span>
                          </div>
                        </div>
                      </template>
                      <span v-else class="no-approver">待处理</span>
                    </div>
                  </div>
                </div>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-dialog>



      <div class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
          layout="total, sizes, prev, pager, next, jumper" :total="page.total">
        </el-pagination>
      </div>
    </el-card>

    <create-order :visible.sync="createDialogVisible" @submit="handleCreateSubmit" />

    <!-- 审核对话框 -->
    <el-dialog title="审核采购订单" :visible.sync="approveDialogVisible" width="500px">
      <el-form :model="approveForm" ref="approveForm" label-width="80px">
        <el-form-item label="审核意见" prop="remark">
          <el-input v-model="approveForm.comment" :rows="4" placeholder="请输入审核意见">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitApprove(1)">驳回</el-button>
        <el-button type="primary" @click="submitApprove(2)">通 过</el-button>
      </div>
    </el-dialog>

    <!-- 添加明细对话框 -->
    <el-dialog title="采购订单明细" :visible.sync="detailDialogVisible" width="800px">
      <div v-loading="detailLoading">
        <el-form :model="detailForm" ref="detailForm" label-width="100px">
          <el-table :data="detailForm.items" border style="width: 100%; margin-bottom: 20px">
            <el-table-column label="商品名称" prop="product_name" min-width="180" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.product_name }}</span>
              </template>
            </el-table-column>

            <el-table-column label="单价" width="150" align="center">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.price" :min="0" :precision="2" :step="0.01"
                  @change="calculateRowAmount(scope.$index)" size="small" controls-position="right">
                </el-input-number>
              </template>
            </el-table-column>

            <el-table-column label="数量" width="150" align="center">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.quantity" :min="1" :precision="0" :step="1"
                  @change="calculateRowAmount(scope.$index)" size="small" controls-position="right">
                </el-input-number>
              </template>
            </el-table-column>

            <el-table-column label="金额" width="150" align="center">
              <template slot-scope="scope">
                <span class="amount-text">{{ formatAmount(scope.row.amount) }}</span>
              </template>
            </el-table-column>
          </el-table>

          <div class="total-amount">
            总金额：<span class="amount">{{ formatAmount(totalAmount) }}</span>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="detailDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>



    <!-- 申请付款对话框 -->
    <el-dialog title="申请付款" :visible.sync="paymentDialogVisible" width="650px" :close-on-click-modal="false"
      custom-class="payment-dialog" class="payment-dialog-scroll">
      <div v-loading="paymentLoading" class="payment-form-wrapper">
        <el-form ref="paymentForm" :model="paymentForm" :rules="paymentRules" label-width="120px">
          <!-- 订单基本信息 -->
          <!-- <el-form-item label="订单名称">
            <el-input v-model="paymentForm.orderName" disabled></el-input>
          </el-form-item> -->
          <el-form-item label="订单总金额">
            <el-input v-model="paymentForm.totalAmount" disabled>
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="已付金额">
            <el-input v-model="paymentForm.paidAmount" disabled>
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <!-- <el-form-item label="申请中金额">
            <el-input v-model="paymentForm.applyingAmount" disabled>
              <template slot="append">元</template>
            </el-input>
          </el-form-item> -->
          <el-form-item label="申请金额" prop="applyAmount">
            <el-input-number v-model="paymentForm.applyAmount" :min="0" :precision="2" :step="100" style="width: 100%"
              controls-position="right">
            </el-input-number>
          </el-form-item>

          <!-- 发票上传 -->
          <el-form-item label="发票上传" prop="invoice">
            <el-upload class="upload-demo" action="/api/api/v1/upload/file" :headers="uploadHeaders"
              :on-success="handleUploadSuccess" 
              :on-error="handleUploadError"
              :on-preview="handlePreview"
              :on-remove="handleRemove" 
              :before-upload="beforeUpload" 
              :file-list="paymentForm.fileList" multiple
              :limit="3">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png/pdf文件，且不超过10MB</div>
            </el-upload>
          </el-form-item>

          <!-- 工作流和收款信息 -->
          <el-form-item label="工作流" prop="workflowId">
            <el-select v-model="paymentForm.workflowId" placeholder="请选择工作流" style="width: 100%">
              <el-option v-for="item in workflowOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="收款类型" prop="paymentType">
            <el-select v-model="paymentForm.paymentType" placeholder="请选择收款类型" style="width: 100%">
              <el-option v-for="item in paymentTypeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="收款渠道" prop="paymentChannel">
            <el-select v-model="paymentForm.paymentChannel" placeholder="请选择收款渠道" style="width: 100%">
              <el-option v-for="item in paymentChannelOptions" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="收款人" prop="payee">
            <el-input v-model="paymentForm.payee"></el-input>
          </el-form-item>

          <el-form-item label="收款账号" prop="accountNo">
            <el-input v-model="paymentForm.accountNo"></el-input>
          </el-form-item>

          <el-form-item label="收款银行" prop="bankName">
            <el-input v-model="paymentForm.bankName"></el-input>
          </el-form-item>

          <el-form-item label="银行行号" prop="bankCode">
            <el-input v-model="paymentForm.bankCode"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="paymentDialogVisible = false">关 闭</el-button>
        <el-button type="primary" @click="submitPayment">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CreateOrder from './components/CreateOrder.vue'
import PageHeader from '@/components/common/PageHeader.vue'
import { getPurchaseOrderList, submitPurchaseOrder, approvePurchaseOrder, getPurchaseOrderDetail } from '@/api/purchase'
import moment from 'moment'
import request from '@/utils/request'


export default {
  name: 'PurchaseOrder',
  components: {
    CreateOrder,
    PageHeader
  },
  data() {
    return {

      flowLoading: false,
      flowDialogVisible: false,
      flowList: [],
      searchForm: {
        orderNo: '',
        status: ''
      },
      orderList: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      createDialogVisible: false,
      listLoading: false,
      approveDialogVisible: false,
      approveForm: {
        comment: '',
        order_id: null,
        approved: -1
      },
      detailDialogVisible: false,
      detailLoading: false,
      detailForm: {
        items: [],
        totalAmount: 0
      },
      paymentDialogVisible: false,
      paymentLoading: false,
      paymentForm: {
        orderId: null,
        orderName: '',
        totalAmount: 0,
        paidAmount: 0,
        applyingAmount: 0,
        applyAmount: 0,
        workflowId: '',
        paymentType: '',
        paymentChannel: '',
        payee: '',
        accountNo: '',
        bankName: '',
        bankCode: '',
        invoice: '',
        fileList: []
      },
      paymentRules: {
        applyAmount: [{ required: true, message: '请输入申请金额', trigger: 'blur' }],
        workflowId: [{ required: true, message: '请选择工作流', trigger: 'change' }],
        paymentType: [{ required: true, message: '请选择收款类型', trigger: 'change' }],
        paymentChannel: [{ required: true, message: '请选择收款渠道', trigger: 'change' }],
        payee: [{ required: true, message: '请输入收款人', trigger: 'blur' }],
        accountNo: [{ required: true, message: '请输入收款账号', trigger: 'blur' }],
        bankName: [{ required: true, message: '请输入收款银行', trigger: 'blur' }],
        bankCode: [{ required: true, message: '请输入银行行号', trigger: 'blur' }]
      },
      workflowOptions: [],
      paymentTypeOptions: [],
      paymentChannelOptions: [],
      uploadHeaders: {
        Authorization: 'Bearer ' + this.$store.getters.token
      },
      currentOrderId: null // 当前操作的订单ID
    }
  },
  computed: {
    totalAmount() {
      return this.detailForm.items.reduce((sum, item) => sum + (item.amount || 0), 0)
    }
  },
  methods: {
    async fetchData() {
      this.listLoading = true
      try {
        const response = await getPurchaseOrderList({
          page: this.page.current,
          size: this.page.size,
          status: this.searchForm.status || -1
        })

        if (response.data && response.data) {
          this.orderList = response.data.map(item => ({
            ...item,
            workFlowName: item.workFlowName || item.workflow_name || '暂无工作流',
            workflowStatus: item.status || 0,
            workflow: item.workflow || {
              nodes: [],
              history: [],
              currentApprover: null,
              lastApprover: null
            }
          }))

          this.page.total = response.data.total || 0
        } else {
          this.orderList = []
          this.page.total = 0
        }
      } catch (error) {
        console.error('获取订单列表失败:', error)
        this.$message.error('获取订单列表失败')
        this.orderList = []
        this.page.total = 0
      } finally {
        this.listLoading = false
      }
    },

    // 查看流程
    async handleShowFlow(row) {
      this.flowLoading = true
      this.flowDialogVisible = true

      try {
        const workflow = row.workflow || { nodes: [] }
        
        if (workflow.nodes && workflow.nodes.length > 0) {
          this.flowList = workflow.nodes.map(node => {
            const approverDetails = (node.approvers || []).map(approver => ({
              name: approver.approver || '未知审批人',
              status: Number(approver.status || 0),
              time: approver.createdAt || approver.approverTime || null,
              comment: approver.approverRemark || approver.remark || ''
            }))

            return {
              title: `${node.nodeName || '未知节点'} ${this.getNodeTypeText(node.nodeType)}`,
              step: node.step || 1,
              status: node.status || 0,
              statusText: this.getNodeStatusText(node.status),
              nodeType: node.nodeType,
              isActive: node.status === 1,
              isCompleted: node.status === 2,
              approverDetails: approverDetails
            }
          })
        } else {
          this.flowList = [{
            title: '暂无流程数据',
            step: 1,
            status: 0,
            statusText: '未开始',
            approverDetails: []
          }]
        }

        console.log('处理后的流程数据:', this.flowList)
      } catch (error) {
        console.error('处理流程数据失败:', error)
        this.$message.error('处理流程数据失败')
        this.flowList = []
      } finally {
        this.flowLoading = false
      }
    },

    getNodeTypeText(nodeType) {
      const typeMap = {
        0: '',           // 默认类型
        1: '(串行审批)', // 串行审批
        2: '(并行与)',   // 并行且签
        3: '(并行或)'    // 并行或签
      }
      return typeMap[nodeType] || ''
    },
    getNodeStatusText(status) {
      const statusMap = {
        0: '未开始',
        1: '进行中',
        2: '已完成',
        3: '已拒绝',
        4: '已取消',
        5: '已终止'
      }
      return statusMap[status] || '未知状态'
    },
    formatDate(timestamp) {
      return moment(timestamp).format('YYYY-MM-DD HH:mm')
    },
    formatDateTime(date) {
      if (!date) return '-'
      const d = new Date(date)
      if (isNaN(d.getTime())) return '-'

      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hour = String(d.getHours()).padStart(2, '0')
      const minute = String(d.getMinutes()).padStart(2, '0')
      const second = String(d.getSeconds()).padStart(2, '0')

      return `${year}/${month}/${day} ${hour}:${minute}:${second}`
    },



    // 获取时间线节点类型
    getTimelineNodeType(status) {
      switch (status) {
        case 2: return 'success'  // 已完成
        case 1: return 'primary'  // 进行中
        case 0: return 'info'     // 未开始
        case 3: return 'danger'   // 已拒绝
        case 4: return 'warning'  // 已取消
        default: return 'info'
      }
    },

    getStatusType(status) {
      const statusMap = {
        0: 'info',    // 未开始
        1: 'info',    // 草稿
        2: 'warning', // 待审核
        3: 'warning', // 审批中
        4: 'success', // 已通过
        5: 'danger',  // 已拒绝
        6: 'info'     // 已取消
      }
      return statusMap[status] || 'info'
    },

    handleCurrentChange(val) {
      this.page.current = val
      this.fetchData()
    },
    handleSizeChange(val) {
      this.page.size = val
      this.page.current = 1
      this.fetchData()
    },
    handleSearch() {
      this.page.current = 1
      this.fetchData()
    },
    resetSearch() {
      this.searchForm = {
        orderNo: '',
        status: ''
      }
      this.handleSearch()
    },
    handleCreate() {
      this.createDialogVisible = true
    },
    handleEdit(row) {
      // 实现编辑逻辑
      console.log('编辑订单:', row)
    },
    async handleDetail(row) {
      this.detailDialogVisible = true
      this.detailLoading = true

      try {
        const details = row.order_details || []
        this.detailForm.items = details.map(item => ({
          product_name: item.goods_name || '未知商品',
          price: item.price || 0,
          quantity: item.quantity || 0,
          amount: item.total_amount || 0,
          detail_id: item.detail_id
        }))
      } catch (error) {
        console.error('处理订单明细失败:', error)
        this.$message.error('处理订单明细失败')
        this.detailForm.items = []
      } finally {
        this.detailLoading = false
      }
    },
    async handleSubmit(row) {
      this.$confirm('确认提交审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await submitPurchaseOrder(row.purchasing_order_id)
          this.$message.success('提交成功')
          await this.fetchData() // 刷新列表
        } catch (error) {
          console.error('提交审核失败:', error)
          this.$message.error(error.message || '提交失败')
        }
      }).catch(() => {
        // 用户取消操作，不做处理
      })
    },
    handleApprove(row) {
      this.approveForm.order_id = row.purchasing_order_id
      this.approveForm.comment = ''

      this.approveDialogVisible = true
    },
    handleCancel(row) {
      this.$confirm('确认取消该订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          // TODO: 调用取消API
          console.log('取消订单:', row)
          this.$message.success('取消成功')
          await this.fetchData()
        } catch (error) {
          this.$message.error('取消失败')
        }
      }).catch(() => { })
    },
    async handlePayment(row) {
      this.paymentDialogVisible = true
      this.paymentLoading = true
      this.currentOrderId = row.purchasing_order_id // 添加这行

      try {
        await Promise.all([
          this.getWorkflowOptions(),  // 获取工作流选项
          this.getPaymentTypeOptions(), // 获取收款类型选项
          this.getPaymentChannelDict() // 获取收款渠道选项
        ])
        this.paymentForm = {
          ...this.paymentForm,
          orderId: row.purchasing_order_id,
          orderName: row.order_name,
          totalAmount: row.money || 0,
          paidAmount: row.pay_money || 0,
          applyingAmount: row.applying_money || 0,
          fileList: []
        }
      } catch (error) {
        console.error('初始化付款申请失败:', error)
        this.$message.error('初始化付款申请失败')
      } finally {
        this.paymentLoading = false
      }
    },
    handleDelete(row) {
      this.$confirm('确认删除该订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          // TODO: 调用删除API
          console.log('删除订单:', row)
          this.$message.success('删除成功')
          await this.fetchData()
        } catch (error) {
          this.$message.error('删除失败')
        }
      }).catch(() => { })
    },
    handleCreateSubmit(formData) {
      // TODO: 调用创建订单API
      console.log('创建订单数据:', formData)
      this.fetchData() // 刷新列表
    },
    // 获取审批人状态类型
    getApproverStatusType(status) {
      const typeMap = {
        0: 'info',    // 未处理
        1: 'warning', // 处理中
        2: 'danger',  // 已拒绝
        3: 'success', // 已通过
        4: 'info',    // 已转交
        5: 'warning'  // 已回退
      }
      return typeMap[status] || 'info'
    },
    // 获取审批人状态文本
    getApproverStatusText(status) {
      const statusMap = {
        0: '未处理',
        1: '处理中',
        2: '已拒绝',
        3: '已通过',
        4: '已转交',
        5: '已回退',
        6: '已终止'
      }
      return statusMap[status] || '未知状态'
    },
    // 获取时间线项目类型
    getTimelineItemType(status) {
      switch (status) {
        case 2: return 'success'  // 已完成
        case 1: return 'primary'  // 进行中
        case 0: return 'info'     // 未开始
        case 3: return 'danger'   // 已拒绝
        case 4: return 'warning'  // 已取消
        default: return 'info'
      }
    },
    getStatusTagType(status) {
      const typeMap = {
        0: 'info',    // 未处理
        1: 'warning', // 处理中
        2: 'danger',  // 已拒绝
        3: 'success', // 已通过
        4: 'info',    // 已转交
        5: 'warning', // 已回退
        6: 'danger'   // 已终止
      }
      return typeMap[status] || 'info'
    },

    handleCommand(command, row) {
      switch (command) {
        case 'edit':
          this.handleEdit(row)
          break
        case 'detail':
          this.handleDetail(row)
          break
        case 'submit':
          this.handleSubmit(row)
          break
        case 'delete':
          this.handleDelete(row)
          break
        case 'approve':
          this.handleApprove(row)
          break
        case 'cancel':
          this.handleCancel(row)
          break
        case 'payment':
          this.handlePayment(row)
          break
      }
    },
    getStatusText(status) {
      const statusMap = {
        0: '未开始',
        1: '草稿',
        2: '待审核',
        3: '审批中',
        4: '已通过',
        5: '已拒绝',
        6: '已取消'
      }
      return statusMap[status] || '未知状态'
    },
    async submitApprove(approved) {
      if (!this.approveForm.comment) {
        this.$message.warning('请输入审核意见')
        return
      }

      try {
        await approvePurchaseOrder({
          order_id: this.approveForm.order_id,
          approved: approved,
          comment: this.approveForm.comment
        })
        this.$message.success('审核完成')
        this.approveDialogVisible = false
        await this.fetchData() // 刷新列表
      } catch (error) {
        console.error('审核失败:', error)
        this.$message.error(error.message || '审核失败')
      }
    },
    async calculateRowAmount(index) {
      const row = this.detailForm.items[index]
      if (!row) return
      row.amount = row.price * row.quantity
      try {
        // 调用接口更新商品明细
        const res = await request({
          url: '/api/v1/purchasing-order/detail/update',
          method: 'post',
          data: {
            detail_id: row.detail_id,
            price: row.price,
            quantity: row.quantity
          }
        })

        if (res.status === 1) {
          // 更新成功后重新计算金额
          row.amount = row.price * row.quantity
          this.$message.success('更新成功')
          await this.fetchData()
        } else {
          this.$message.error(res.msg || '更新失败')
          // 更新失败时回滚数据
          await this.fetchData()
        }
      } catch (error) {
        console.error('更新商品明细失败:', error)
        this.$message.error('更新失败')
        // 发生错误时回滚数据
        await this.fetchData()
      }
    


  },
  formatAmount(amount) {
    return `¥${amount.toFixed(2)}`
  },
  handlePreview(file) {
    if (file.url) {
      window.open(file.url)
    }
  },
  handleRemove(file, fileList) {
    this.paymentForm.fileList = fileList
    this.paymentForm.invoice = '' // 清空发票路径
  },
  handleUploadSuccess(response, file, fileList) {
    if (response.status === 1) {
      this.$message.success('上传成功')
      this.paymentForm.invoice = response.data.SavePath
      // 将文件信息添加到表单数据中
      // const fileInfo = {
      //   name: response.data.Filename,
      //   url: response.data.url,
      //   size: response.data.Size,
      //   type: response.data.Type,
      //   uploadTime: response.data.UploadTime,
      //   invoice: response.data.SavePath
      // }
      // this.paymentForm.fileList = fileList.map(item => {
      //   if (item.uid === file.uid) {
      //     return {
      //       ...item,
      //       ...fileInfo
      //     }
      //   }
      //   return item
      // })
    } else {
      this.$message.error('上传失败')
    }
  },
  handleUploadError(err) {
    console.error('上传失败:', err)
    this.$message.error('上传失败，请重试')
  },
  beforeUpload(file) {
    const isValidType = ['image/jpeg', 'image/png', 'application/pdf'].includes(file.type)
    const isLt10M = file.size / 1024 / 1024 < 10

    if (!isValidType) {
      this.$message.error('只能上传 JPG/PNG/PDF 格式的文件!')
      return false
    }
    if (!isLt10M) {
      this.$message.error('文件大小不能超过 10MB!')
      return false
    }
    return true
  },
  async submitPayment() {
    try {
      await this.$refs.paymentForm.validate()

      // 构造请求参数
      const params = {
      order_id: this.currentOrderId, // 需要在打开付款对话框时保存订单ID
      invoice_path: this.paymentForm.invoice,
      amount: this.paymentForm.applyAmount,
      remark: this.paymentForm.remark || '预付款',
      work_flow_id: this.paymentForm.workflowId,
      pay_channel: this.paymentForm.paymentChannel,
      pay_account: this.paymentForm.accountNo,
      pay_type: this.paymentForm.paymentType,
      supplier_pay_method: this.paymentForm.paymentType,
      supplier_pay_channel: this.paymentForm.paymentChannel,
      supplier_bank_name: this.paymentForm.bankName,
      supplier_bank_account: this.paymentForm.accountNo,
      supplier_bank_code: this.paymentForm.bankCode,
      supplier_name: this.paymentForm.payee
      }

      // 调用付款申请API
      const res = await request({
        url: '/api/v1/purchasing-order/payment/save',
        method: 'post',
        data: params
      })

      if (res.status === 1) {
        this.$message.success('提交成功')
        this.paymentDialogVisible = false
        this.fetchData() // 刷新列表
      } else {
        this.$message.error(res.msg || '提交失败')
      }
    } catch (error) {
      console.error('提交付款申请失败:', error)
      this.$message.error('提交失败')
    }
  },
  // 获取工作流选项
  async getWorkflowOptions() {
    try {
      const res = await request({
        url: '/api/v1/process/by-type',
        method: 'post',
        data: {
          code: '100005' // 采购订单付款审批流程
        }
      })
      if (res.status === 1 && res.data) {
        this.workflowOptions = res.data.map(item => ({
          value: item.processId,
          label: item.processName
        }))
      }
    } catch (error) {
      console.error('获取工作流失败:', error)
      this.$message.error('获取工作流失败')
    }
  },
  // 获取收款类型选项
  async getPaymentTypeOptions() {
    try {
      const res = await request({
        url: '/api/v1/dict/type',
        method: 'post',
        data: {
          dictType: 'GYSSKFS',
          dictItemName: ''
        }
      })
      if (res.status === 1 && res.data) {
        this.paymentTypeOptions = res.data.map(item => ({
          value: item.itemValue,
          label: item.itemLabel
        }))
      }
    } catch (error) {
      console.error('获取收款类型失败:', error)
      this.$message.error('获取收款类型失败')
    }
  },
  // 获取收款渠道字典
  async getPaymentChannelDict() {
    try {
      const res = await request({
        url: '/api/v1/dict/type',
        method: 'post',
        data: {
          dictType: 'GYSSKQD',
          dictItemName: ''
        }
      })
      if (res.status === 1 && res.data) {
        this.paymentChannelOptions = res.data.map(item => ({
          value: item.itemValue,
          label: item.itemLabel
        }))
      }
    } catch (error) {
      console.error('获取收款渠道失败:', error)
      this.$message.error('获取收款渠道失败')
    }
  }
},

  

created() {
  this.fetchData()
}
}
</script>

<style lang="scss" scoped>
.pending-status {
  color: #f56c6c !important;
  border-color: #f56c6c !important;
  background-color: #fef0f0 !important;

  &:hover {
    opacity: 0.8;
  }
}

.app-container {
  padding: 20px;

  .filter-container {
    padding-bottom: 10px;

    .filter-item {
      vertical-align: middle;
    }
  }

  .el-button {
    &+.el-button {
      margin-left: 5px;
    }
  }

  .el-table {
    .el-tag {
      margin: 2px 0;
    }

    .el-button {
      padding: 7px 12px;
    }
  }

  .timeline-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    font-weight: bold;
  }

  .timeline-content {
    color: #666;
    font-size: 13px;
    line-height: 1.5;
  }

  .el-tag {
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }

  .workflow-btn {
    display: inline-flex;
    align-items: center;
    color: #409EFF;

    &:hover {
      color: #66b1ff;

      .el-icon--right {
        transform: scale(1.2);
      }
    }

    .el-icon--right {
      margin-left: 5px;
      transition: transform 0.3s ease;
    }
  }
}

.dealer-manage {

  background-color: #f0f2f5;
  min-height: calc(100vh - 84px);

  .search-card,
  .table-card {
    background: #fff;
    border-radius: 4px;
    margin-bottom: 20px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
    padding: 0;
  }

  .filter-container {
    padding-bottom: 10px;
  }

  .operation-container {
    margin-bottom: 20px;
  }

  .pagination-container {
    padding: 20px 0;
    text-align: right;
  }

  .el-form-item {
    margin-bottom: 20px;
  }

  .upload-demo {
    margin-bottom: 20px;
  }

  .el-upload__tip {
    line-height: 1.2;
    margin-top: 5px;
    color: #909399;
  }
}

.flow-dialog {
  .flow-container {
    padding: 20px 10px;
  }

  ::v-deep .el-timeline {
    padding: 0 20px;

    .el-timeline-item {
      padding-bottom: 25px;

      &:last-child {
        padding-bottom: 0;
      }

      .el-timeline-item__node {
        &--large {
          width: 14px;
          height: 14px;
        }

        &.is-success {
          background-color: #67C23A;
        }

        &.is-warning {
          background-color: #E6A23C;
        }

        &.is-danger {
          background-color: #F56C6C;
        }
      }

      .el-timeline-item__wrapper {
        padding-left: 25px;
      }
    }
  }

  .flow-item {
    background: #f8f9fa;
    border-radius: 4px;
    padding: 15px;
    margin-bottom: 10px;

    .flow-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;

      .flow-title {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 500;

        .step-tag {
          background: #ecf5ff;
          color: #409eff;
          padding: 2px 6px;
          border-radius: 4px;
          margin-right: 8px;
          font-size: 12px;
        }
      }
    }

    .flow-content {
      .flow-info {
        .info-header {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          color: #606266;

          i {
            margin-right: 5px;
          }
        }

        .approver-list {
          .approver-item {
            padding: 10px 0;
            border-bottom: 1px dashed #ebeef5;

            &:last-child {
              border-bottom: none;
            }

            .approver-row {
              display: flex;
              align-items: center;
              gap: 12px;

              .approver-name {
                font-weight: 500;
                min-width: 80px;
              }

              .approve-time {
                color: #909399;
                font-size: 12px;
              }
            }

            .approve-comment {
              margin-top: 8px;
              padding-left: 2px;
              color: #606266;
              font-size: 13px;

              .comment-label {
                color: #909399;
                margin-right: 8px;
              }
            }
          }
        }

        .no-approver {
          color: #909399;
          font-size: 13px;
        }
      }
    }
  }
}

::v-deep .el-timeline-item__node {
  &.is-success {
    background-color: #67C23A;
  }

  &.is-warning {
    background-color: #E6A23C;
  }

  &.is-danger {
    background-color: #F56C6C;
  }
}

.form-section {
  margin-bottom: 20px;

  .section-title {
    font-size: 15px;
    font-weight: 500;
    color: #303133;
    margin-bottom: 20px;
    padding-left: 10px;
    border-left: 3px solid #409EFF;
  }
}

::v-deep .el-input-number {
  width: 100%;
}

::v-deep .el-rate {
  height: 40px;
  line-height: 40px;

  .el-rate__text {
    margin-left: 10px;
    font-size: 14px;
  }
}

::v-deep .el-input-group__prepend {
  background-color: #f5f7fa;
  color: #909399;
  width: 40px;
}

::v-deep .el-textarea__inner {
  font-family: inherit;
}

.operation-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 5px;
  padding: 5px 0;

  .el-button {
    margin: 0;
    min-width: 76px;
  }
}

.approve-dialog {
  .el-message-box__header {
    padding: 15px 20px;
    border-bottom: 1px solid #ebeef5;

    .el-message-box__title {
      font-size: 16px;
      font-weight: 500;
    }

    .el-message-box__headerbtn {
      top: 15px;
      right: 20px;

      &:hover .el-message-box__close {
        color: #409EFF;
      }
    }
  }

  .el-message-box__content {
    padding: 20px;

    .el-message-box__input {
      padding-top: 15px;

      .el-input__inner {
        height: 80px;
        padding: 5px 10px;
        font-size: 14px;
        resize: none;
      }
    }
  }

  .el-message-box__btns {
    padding: 10px 20px 20px;
    text-align: right;

    .el-button {
      padding: 9px 20px;

      &+.el-button {
        margin-left: 10px;
      }
    }
  }
}

.flow-item {
  .flow-header {
    .step-tag {
      background-color: #f0f2f5;
      padding: 2px 6px;
      border-radius: 4px;
      margin-right: 8px;
      font-size: 12px;
      color: #606266;
    }

    .flow-title {
      display: flex;
      align-items: center;

      span+span {
        margin-left: 4px;
        color: #909399;
        font-size: 13px;
      }
    }
  }
}

.flow-content {
  .flow-info {
    .approver-list {
      margin-left: 5px;

      .approver-item {
        border-bottom: 1px dashed #DCDFE6;
        padding: 8px 0;

        &:last-child {
          border-bottom: none;
        }

        .approver-row {
          display: flex;
          align-items: center;
          gap: 12px;

          .approver-name {
            font-size: 13px;
            font-weight: 500;
            color: #303133;
            min-width: 80px;
          }

          .el-tag {
            height: 22px;
            line-height: 20px;
            padding: 0 8px;
            font-size: 12px;
            min-width: 64px;
            text-align: center;
          }

          .approve-comment {
            flex: 1;
            color: #606266;
            font-size: 13px;
            padding-left: 12px;
            margin: 0 12px;
            border-left: 2px solid #EBEEF5;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .approve-time {
            color: #909399;
            font-size: 12px;
            white-space: nowrap;
            min-width: 135px;
          }

          /* 添加待审批状态样式 */
          .approver-row {
            .el-tag {
              &.pending {
                color: #f56c6c;
                border-color: #f56c6c;
                background-color: #fef0f0;
              }
            }
          }
        }
      }
    }
  }
}

.el-dropdown {
  margin: 0 5px;
}

.el-dropdown-menu {
  .el-dropdown-item {
    display: flex;
    align-items: center;
    padding: 8px 16px;

    i {
      margin-right: 8px;
      font-size: 16px;
    }

    &:hover {
      background-color: #ecf5ff;
      color: #409EFF;
    }
  }
}

.total-amount {
  text-align: right;
  margin-top: 20px;
  padding-right: 20px;
  font-size: 14px;

  .amount {
    font-size: 18px;
    color: #f56c6c;
    margin-left: 8px;
    font-weight: bold;
  }
}

.amount-text {
  color: #606266;
  font-weight: 500;
}

::v-deep .el-input-number {
  width: 100%;

  .el-input__inner {
    text-align: right;
  }
}

.el-dialog {
  .el-table {
    margin-bottom: 20px;
  }

  .dialog-footer {
    text-align: right;
  }
}

.payment-dialog {
  .el-message-box__content {
    max-height: 400px;
    overflow-y: auto;
  }
}

// 新增样式
.payment-dialog-scroll {
  .el-dialog__body {
    padding: 20px;
  }

  .payment-form-wrapper {
    padding-right: 10px; // 防止滚动条遮挡内容

    /* 自定义滚动条样式 */
    &::-webkit-scrollbar {
      width: 6px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-track {
      background-color: #f5f5f5;
    }
  }
}
</style>